import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SAManagement\GetTenantProdDatabaseDumpController::__invoke
* @see app/Http/Controllers/SAManagement/GetTenantProdDatabaseDumpController.php
* @route '/api/sa-management/dump'
*/
const GetTenantProdDatabaseDumpController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTenantProdDatabaseDumpController.url(options),
    method: 'get',
})

GetTenantProdDatabaseDumpController.definition = {
    methods: ["get","head"],
    url: '/api/sa-management/dump',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SAManagement\GetTenantProdDatabaseDumpController::__invoke
* @see app/Http/Controllers/SAManagement/GetTenantProdDatabaseDumpController.php
* @route '/api/sa-management/dump'
*/
GetTenantProdDatabaseDumpController.url = (options?: RouteQueryOptions) => {
    return GetTenantProdDatabaseDumpController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SAManagement\GetTenantProdDatabaseDumpController::__invoke
* @see app/Http/Controllers/SAManagement/GetTenantProdDatabaseDumpController.php
* @route '/api/sa-management/dump'
*/
GetTenantProdDatabaseDumpController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTenantProdDatabaseDumpController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SAManagement\GetTenantProdDatabaseDumpController::__invoke
* @see app/Http/Controllers/SAManagement/GetTenantProdDatabaseDumpController.php
* @route '/api/sa-management/dump'
*/
GetTenantProdDatabaseDumpController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetTenantProdDatabaseDumpController.url(options),
    method: 'head',
})

export default GetTenantProdDatabaseDumpController